import { IonFooter, IonModal, IonText, useIonRouter } from "@ionic/react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import confetti from "canvas-confetti";
import { CoreValueAvatarWithBackground } from "@/components/CoreValue/AvatarWithBackground";
import { Button } from "@/components/Global/Button";
import { Content } from "@/components/Global/Content";
import { Routes } from "@/lib/router";
import { useSelectorModalStore } from "@/lib/store/modal";

export function ModalCoreValuesFinished() {
	const { t } = useTranslation();
	const modalRef = useRef<HTMLIonModalElement>(null);
	const modal = useSelectorModalStore.use.coreValuesFinished();
	const present = useSelectorModalStore.use.present();
	const dismiss = useSelectorModalStore.use.dismiss();
	const router = useIonRouter();

	const presentConfetti = () => {
		confetti({
			particleCount: 500,
			origin: {
				x: 0.5,
				y: 1.2,
			},
			decay: 0.95,
		});
	};

	return (
		<IonModal
			ref={modalRef}
			isOpen={modal.isOpen}
			onWillPresent={() => {
				present("coreValuesFinished");
			}}
			onDidPresent={() => {
				presentConfetti();
			}}
			onWillDismiss={() => {
				dismiss("coreValuesFinished");
			}}
			className="ion-rounded-4xl"
		>
			<Content inModal className="part-scroll:gap-0 part-scroll:p-4 part-scroll:pt-2">
				<div className="flex flex-col items-center gap-4">
					<CoreValueAvatarWithBackground className="my-8" />
					<IonText className="text-brown-700 text-center text-2xl font-bold">
						{t("modal.core-values.finished.title")}
					</IonText>
					<IonText className="text-md text-brown-600 text-center">
						{t("modal.core-values.finished.description")}
					</IonText>
				</div>
			</Content>
			<IonFooter className="p-4">
				<Button
					data-attr="modal.core-values.finished.close"
					className="mt-8 w-full"
					onClick={() => {
						modalRef.current?.dismiss();
						router.push(Routes.Dashboard(), "forward");
					}}
				>
					{t("modal.core-values.finished.close")}
				</Button>
			</IonFooter>
		</IonModal>
	);
}
